import { any, all, curry, equals } from "ramda"
import isRequired from "./isRequired"
// contactPerson: {
//   title: HardCodeSalutation[0],
//   firstName: "",
//   lastName: ""
// },

//fields: ["title", "firstName", "lastName"]

export default curry((fields, checkAll, { value }) => {
  //[true, false, true]
  const validatedResult = fields.map((field) => {
    const fieldValue = value[field]
    return isRequired({ value: fieldValue })
  })
  let equalTrue = equals(true)
  const isPass = checkAll ? all(equalTrue)(validatedResult) : any(equalTrue)(validatedResult)
  return isPass
})
